import { Box, IconButton, Paper, Popper, Typography } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { ReactNode, useState } from 'react'

import LayersButton from './button'
import LayersList from './layers-list'
import { useStyles } from './styles'

export interface LayerDefinition {
  label: ReactNode
  checked: boolean
  disabled: boolean
}

export interface LayersConfig {
  [key: string]: LayerDefinition
}

interface LayersViewBoxProps {
  layersConfig: LayersConfig
  onLayerChange: (layer: string, checked: boolean) => void
  title: string
  placement?: 'topleft' | 'topright' | 'bottomleft' | 'bottomright'
  defaultOpen?: boolean
}

export const LayersViewControl = ({
  layersConfig,
  onLayerChange,
  title,
  placement = 'bottomright',
  defaultOpen = false,
}: LayersViewBoxProps) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handleLayerChange = (layerName: string, checked: boolean) => {
    onLayerChange(layerName, checked)
  }

  const handleLayersClose = () => {
    setAnchorEl(null)
  }

  return (
    <Box>
      <LayersButton
        anchorEl={anchorEl}
        setAnchorEl={setAnchorEl}
        placement={placement}
        defaultOpen={defaultOpen}
      />
      <Popper
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        placement='top-start'
        disablePortal={false}
        className={classes.popper}
      >
        <Paper className={classes.layersViewBox} elevation={2}>
          <Box className={classes.header}>
            <Typography variant='subtitle2' className={classes.title}>
              {title}
            </Typography>
            <IconButton
              size='medium'
              className={classes.closeButton}
              onClick={handleLayersClose}
              aria-label='Fechar'
            >
              <CloseIcon fontSize='small' />
            </IconButton>
          </Box>
          <LayersList
            layersConfig={layersConfig}
            handleLayerChange={handleLayerChange}
          />
        </Paper>
      </Popper>
    </Box>
  )
}
